const emptyIfNull = (value) => (value == null ? "" : value);

export function getZatcaFetchUrl(tenantId) {
  return `https://api-pos.hulmsolutions.com/api/fatoora/${encodeURIComponent(tenantId)}`;
}

export function getZatcaPosCheckoutUrl(tenantId) {
  return `${getZatcaFetchUrl(tenantId)}/pos/checkout`;
}

export function getZatcaB2bCheckoutUrl(tenantId) {
  return `${getZatcaFetchUrl(tenantId)}/b2b/checkout`;
}

export function buildZatcaFormDefaults(tenantId = "") {
  return {
    tenantId,
    companyName: tenantId,
    email: "",
    phone: "",
    name: "",
    vatNumber: "",
    crNumber: "",
    taxNumber: "",
    address: {
      street: "",
      buildingNumber: "",
      district: "",
      city: "",
      postalCode: "",
      country: "SA",
    },
  };
}

/** Map GET /api/fatoora/{tenantId} response into form fields. */
export function mapZatcaApiToFormData(data, tenantId = "") {
  if (!data) {
    return buildZatcaFormDefaults(tenantId);
  }

  return {
    tenantId: emptyIfNull(data.tenantId) || tenantId,
    companyName: emptyIfNull(data.companyName) || tenantId,
    email: emptyIfNull(data.email),
    phone: emptyIfNull(data.phone),
    name: emptyIfNull(data.name),
    vatNumber: emptyIfNull(data.vatNumber),
    crNumber: emptyIfNull(data.crNumber),
    taxNumber: emptyIfNull(data.taxNumber) || emptyIfNull(data.vatNumber),
    address: {
      street: emptyIfNull(data.address?.street),
      buildingNumber: emptyIfNull(data.address?.buildingNumber),
      district: emptyIfNull(data.address?.district),
      city: emptyIfNull(data.address?.city),
      postalCode: emptyIfNull(data.address?.postalCode),
      country: emptyIfNull(data.address?.country),
    },
  };
}

export function buildZatcaSetupPayload(formData, { companyName, phone } = {}) {
  const tenantId = formData.tenantId || companyName || "";
  const resolvedCompanyName = formData.companyName || companyName || "";
  const vatNumber = formData.vatNumber || "";

  return {
    tenantId,
    companyName: resolvedCompanyName,
    email: formData.email || "",
    name: formData.name || resolvedCompanyName,
    vatNumber,
    crNumber: formData.crNumber || "",
    taxNumber: formData.taxNumber || vatNumber,
    phone: formData.phone || phone || "",
    address: {
      street: formData.address?.street || "",
      buildingNumber: formData.address?.buildingNumber || "",
      district: formData.address?.district || "",
      city: formData.address?.city || "",
      postalCode: formData.address?.postalCode || "",
      country: formData.address?.country || "SA",
    },
  };
}

export const processZATCAInvoice = (tenantId, data, token) => {
  return fetch(getZatcaPosCheckoutUrl(tenantId), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (token || "my-token"),
    },
    body: JSON.stringify(data),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  });
};

export const getZatcaInformation = (tenantId, token) => {
  if (!tenantId) {
    return Promise.reject(new Error("Tenant ID is required to fetch ZATCA data."));
  }

  return fetch(getZatcaFetchUrl(tenantId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (token || "my-token"),
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else if (response.status === 404) {
      return null;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  });
};

export const setupZatcaInformation = (payload, token) => {
  return fetch("https://api-pos.hulmsolutions.com/api/setup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (token || "my-token"),
    },
    body: JSON.stringify(payload),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  });
};
